import React, { FC } from 'react';
import { BoxProps, CONTENT_PADDING, CONTENT_WIDTH } from 'enova-frontend-components';

import { useMediaQuery } from '../../../hooks/useMediaQuery';
import { useUser } from '../../../hooks/useUser';
import { AppRoute, hasPermission, MainScreenTab } from '../../../utils/navigation';

import { TabMenuButton } from './tabMenuButton';
import { DropDownMenu } from './dropDownMenu';
import { DropDownMenuItem } from './dropDownMenuItem';
import { TabMenu } from './styledComponents';

export const MainMenu: FC<BoxProps> = () => {
  const { xsScreen } = useMediaQuery();
  const { user } = useUser();
  const isExpertUser = hasPermission(AppRoute.EXPERT_REGISTRATION, user);

  // Dropdown menu for small screens
  if (xsScreen) {
    return (
      <DropDownMenu>
        <DropDownMenuItem tab={MainScreenTab.BUILDINGS} />
        <DropDownMenuItem tab={MainScreenTab.OTHERS_BUILDINGS} />
        <DropDownMenuItem tab={MainScreenTab.SEARCH} />

        {/* This view is for expert users only */}
        {isExpertUser && <DropDownMenuItem tab={MainScreenTab.EXPERT_REGISTRATION} />}
      </DropDownMenu>
    );
  }

  // Tab menu for larger screens
  return (
    <TabMenu mt={2} width={CONTENT_WIDTH.xs} px={CONTENT_PADDING}>
      <TabMenuButton tab={MainScreenTab.BUILDINGS} />
      <TabMenuButton tab={MainScreenTab.OTHERS_BUILDINGS} />
      <TabMenuButton tab={MainScreenTab.SEARCH} />

      {/* This view is for expert users only */}
      {isExpertUser && <TabMenuButton tab={MainScreenTab.EXPERT_REGISTRATION} />}
    </TabMenu>
  );
};
